<template>
  <ClassicAuthCard
    v-if="classic"
    :title="title"
    :subtitle="subtitle"
    :is-admin="isAdmin"
    :register-url="classicRegisterUrl"
  >
    <template v-if="$slots['classic-title']" #title>
      <slot name="classic-title" />
    </template>
    <template v-if="$slots['classic-subtitle']" #subtitle>
      <slot name="classic-subtitle" />
    </template>
    <slot />
    <template v-if="$slots.footer" #footer>
      <slot name="footer" />
    </template>
  </ClassicAuthCard>

  <AuthShell
    v-else
    :sidebar-title="sidebarTitle"
    :sidebar-text="sidebarText"
    :support-phone="supportPhone"
    :is-admin="isAdmin"
    :mode="mode"
    :register-progress="progressSteps.length > 0"
    :terms-link="legalLinks.termsLink"
    :privacy-link="legalLinks.privacyLink"
    :consent-link="legalLinks.consentLink"
  >
    <template v-if="progressSteps.length" #sidebar-progress>
      <AuthProgressStepper :steps="progressSteps" :current-step="progressCurrentStep" />
    </template>

    <AuthCard v-if="card" :title="title" :subtitle="subtitle" :header-centered="headerCentered">
      <template v-if="$slots.subtitle" #subtitle>
        <slot name="subtitle" />
      </template>
      <slot />
      <template v-if="$slots['card-links']" #card-links>
        <slot name="card-links" />
      </template>
      <template v-if="$slots.footer" #footer>
        <slot name="footer" />
      </template>
    </AuthCard>

    <template v-else>
      <h2 v-if="title" class="auth-login__panel-title" tabindex="-1" data-step-focus>{{ title }}</h2>
      <p v-if="subtitle || $slots.subtitle" class="auth-login__panel-subtitle">
        <slot name="subtitle">{{ subtitle }}</slot>
      </p>
      <slot />
    </template>
  </AuthShell>
</template>

<script setup>
import { computed, inject } from 'vue'
import AuthShell from './AuthShell.vue'
import AuthCard from './AuthCard.vue'
import AuthProgressStepper from './AuthProgressStepper.vue'
import ClassicAuthCard from '../../classic/components/ClassicAuthCard.vue'

const props = defineProps({
  sidebarTitle: { type: String, required: true },
  sidebarText:  { type: String, default: '' },
  supportPhone:   { type: String, default: '815-908-2020' },
  title:          { type: String, default: '' },
  subtitle:       { type: String, default: '' },
  headerCentered: { type: Boolean, default: false },
  card:           { type: Boolean, default: true },
  isAdmin:        { type: Boolean, default: false },
  mode:           { type: String, default: 'login' },
  progressSteps:  { type: Array, default: () => [] },
  progressCurrentStep: { type: Number, default: 0 },
  classic:        { type: Boolean, default: false },
  classicRegisterUrl: { type: String, default: '/register' },
})

const legalLinks = inject('authLegalLinks', computed(() => ({
  termsLink: '',
  privacyLink: '',
  consentLink: '',
})))
</script>
